import { render, staticRenderFns } from "./MsisdnSummaryField.vue?vue&type=template&id=60036234&"
import script from "./MsisdnSummaryField.vue?vue&type=script&lang=js&"
export * from "./MsisdnSummaryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports